import { Box, Button, Card, Grid, Typography, useMediaQuery } from "@mui/material";
import { DownArrowIcon, DownloadIcon, UpArrowIcon } from "../../../components/Icons";
import ExportToCsv from "../../../components/ExportToCsv";
import DataTable from "../../../components/DataTable";
import {
  bindDollar,
  centToDollar,
  filterOBJ,
  format1,
  PHONE_CODE,
  scratchEventStaticDays,
  toLocalISOString
} from "../../../utils/custom";
import moment from "moment-timezone";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";
import ListFilterMain from "./filter/MyFilterMain";
import ScratchEventLayout from "../SubscriptionTab";
import { getScratchEventHistoryList } from "../redux/action";

const initial = {
  activeDateStart: "",
  activeDateEnd: "",
  expiryDateStart: "",
  expiryDateEnd: "",
  search: "",
  // status: "",
  userId: "",
  scratchEventId: "",
  key: "startDate",
  desc: true,
  page: 1,
  limit: 10
};

const getInitialScratchEventId = () => new URLSearchParams(window.location.search).get("scratchEventId") || "";

const ScratchEventHistory = ({ name = "" }) => {
  const { userScratchEventsHistory, isLoading } = useSelector((state) => state.scratchEvent);
  const { user } = useSelector((state) => state.auth);

  const [dataFilter, setDataFilter] = useState(() => ({ ...initial, scratchEventId: getInitialScratchEventId() }));
  const [payLoadData, setPayloadData] = useState(() => ({ ...initial, scratchEventId: getInitialScratchEventId() }));
  const [selectFilter, setSelectFilter] = useState(() => (getInitialScratchEventId() ? ["Scratch Event"] : []));

  const dispatch = useDispatch();
  const { palette, breakpoints } = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();

  const isSmall = useMediaQuery(breakpoints.down("sm") || breakpoints.down("xs"));
  const gridSpacing = isSmall ? 2 : 3;

  const handleSort = (item) => () => {
    if (dataFilter.key !== item) {
      setDataFilter({ ...dataFilter, key: item, desc: true });
    } else {
      if (dataFilter.desc === true) {
        setDataFilter({ ...dataFilter, key: item, desc: false });
      } else {
        setDataFilter({ ...dataFilter, key: "id", desc: true });
      }
    }
  };

  const onBatchChange = (e, newPage) => {
    setDataFilter({ ...dataFilter, page: newPage + 1 });
  };

  const tableConstants = ({ handleSort }) => {
    return [
      {
        title: <span className="cursor-pointer">Sr. No</span>,
        render: (rowData) => {
          return <span>{rowData.index}</span>;
        }
      },
      {
        title: (
          <Box sx={{ cursor: "pointer", display: "flex" }} onClick={handleSort("eventName")}>
            Event Name
            <Box sx={{ ml: 1, color: dataFilter.key === "eventName" ? palette.primary.main : palette.grey.main }}>
              {dataFilter.key === "eventName" && dataFilter.desc === true && <DownArrowIcon width={12} height={12} />}
              {dataFilter.key === "eventName" && dataFilter.desc === false && <UpArrowIcon width={12} height={12} />}
              {dataFilter.key !== "eventName" && <UpArrowIcon width={12} height={12} />}
            </Box>
          </Box>
        ),
        render: (rowData) => {
          return user.userRole.includes("scratch_event_edit") ? (
            <NavLink className="link" to={`/scratch-event/edit/${rowData?.eventId}`}>
              {rowData?.eventName}
            </NavLink>
          ) : (
            <Typography variant="span" sx={{ textTransform: "capitalize" }}>
              {rowData?.eventName}
            </Typography>
          );
        }
      },
      {
        title: (
          <Box sx={{ cursor: "pointer", display: "flex" }} onClick={handleSort("phone")}>
            Customer
            <Box sx={{ ml: 1, color: dataFilter.key === "phone" ? palette.primary.main : palette.grey.main }}>
              {dataFilter.key === "phone" && dataFilter.desc === true && <DownArrowIcon width={12} height={12} />}
              {dataFilter.key === "phone" && dataFilter.desc === false && <UpArrowIcon width={12} height={12} />}
              {dataFilter.key !== "phone" && <UpArrowIcon width={12} height={12} />}
            </Box>
          </Box>
        ),
        render: (rowData) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center", textTransform: "capitalize" }}>
              <div>
                {rowData.firstName || rowData.lastName !== " " ? (
                  <div>{`${rowData.firstName} ${rowData.lastName}`}</div>
                ) : (
                  "--"
                )}
                <div>
                  {PHONE_CODE} {rowData?.phone}
                </div>
              </div>
            </Box>
          );
        }
      },
      {
        title: (
          <Box sx={{ cursor: "pointer", display: "flex" }} onClick={handleSort("user.startDate")}>
            Activate At
            <Box sx={{ ml: 1, color: dataFilter.key === "user.startDate" ? palette.primary.main : palette.grey.main }}>
              {dataFilter.key === "user.startDate" && dataFilter.desc === true && (
                <DownArrowIcon width={12} height={12} />
              )}
              {dataFilter.key === "user.startDate" && dataFilter.desc === false && (
                <UpArrowIcon width={12} height={12} />
              )}
              {dataFilter.key !== "user.startDate" && <UpArrowIcon width={12} height={12} />}
            </Box>
          </Box>
        ),
        render: (rowData) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center", textTransform: "capitalize" }}>
              {moment.utc(rowData.startDate).format(format1)}
            </Box>
          );
        }
      },
      {
        title: (
          <Box sx={{ cursor: "pointer", display: "flex" }} onClick={handleSort("totalRecharge")}>
            Total Recharge
            <Box sx={{ ml: 1, color: dataFilter.key === "totalRecharge" ? palette.primary.main : palette.grey.main }}>
              {dataFilter.key === "totalRecharge" && dataFilter.desc === true && (
                <DownArrowIcon width={12} height={12} />
              )}
              {dataFilter.key === "totalRecharge" && dataFilter.desc === false && (
                <UpArrowIcon width={12} height={12} />
              )}
              {dataFilter.key !== "totalRecharge" && <UpArrowIcon width={12} height={12} />}
            </Box>
          </Box>
        ),
        render: (rowData) => {
          return (
            <Typography variant="span" sx={{ textTransform: "capitalize" }}>
              {bindDollar(centToDollar(rowData?.totalRecharge))}
            </Typography>
          );
        }
      },
      {
        title: (
          <Box sx={{ cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ cursor: "pointer", display: "flex" }}>Day {scratchEventStaticDays[0].value}</div>
            <div>Level / Required / Received</div>
          </Box>
        ),
        render: (rowData) => {
          const findEvent = rowData?.scratchCards?.find((d) => {
            return d.day === scratchEventStaticDays[0].value;
          });
          return (
            <div style={{ textTransform: "capitalize", textAlign: "center" }}>
              {findEvent ? (
                findEvent?.status === "expired" ? (
                  "Expired"
                ) : (
                  <>
                    {findEvent?.level}/{bindDollar(centToDollar(findEvent?.rechargeRequired))}/
                    {bindDollar(centToDollar(findEvent?.rewardAmount))}
                  </>
                )
              ) : (
                "Unscratched"
              )}
            </div>
          );
        }
      },
      {
        title: (
          <Box sx={{ cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ cursor: "pointer", display: "flex" }}>Day {scratchEventStaticDays[1].value}</div>
            <div>Level / Required / Received</div>
          </Box>
        ),
        render: (rowData) => {
          const findEvent = rowData?.scratchCards?.find((d) => {
            return d.day === scratchEventStaticDays[1].value;
          });
          return (
            <div style={{ textTransform: "capitalize", textAlign: "center" }}>
              {findEvent ? (
                findEvent?.status === "expired" ? (
                  "Expired"
                ) : (
                  <>
                    {findEvent?.level}/{bindDollar(centToDollar(findEvent?.rechargeRequired))}/
                    {bindDollar(centToDollar(findEvent?.rewardAmount))}
                  </>
                )
              ) : (
                "Unscratched"
              )}
            </div>
          );
        }
      },
      {
        title: (
          <Box sx={{ cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ cursor: "pointer", display: "flex" }}>Day {scratchEventStaticDays[2].value}</div>
            <div>Level / Required / Received</div>
          </Box>
        ),
        render: (rowData) => {
          const findEvent = rowData?.scratchCards?.find((d) => {
            return d.day === scratchEventStaticDays[2].value;
          });
          return (
            <div style={{ textTransform: "capitalize", textAlign: "center" }}>
              {findEvent ? (
                findEvent?.status === "expired" ? (
                  "Expired"
                ) : (
                  <>
                    {findEvent?.level}/{bindDollar(centToDollar(findEvent?.rechargeRequired))}/
                    {bindDollar(centToDollar(findEvent?.rewardAmount))}
                  </>
                )
              ) : (
                "Unscratched"
              )}
            </div>
          );
        }
      },
      {
        title: <span className="cursor-pointer">Expire Date</span>,
        render: (rowData) => {
          return <span>{moment.utc(rowData?.expiryDate).format("MM/DD/YYYY")}</span>;
        }
      }
    ];
  };

  const scratched = (scratch, index = 0) => {
    return scratch?.length > 0
      ? `
          ${scratch[index]?.level} / ${centToDollar(scratch[index]?.rechargeRequired)} / ${centToDollar(
            scratch[index]?.rewardAmount
          )}
        `
      : "Unscratched";
  };

  const dataExport = () => {
    return userScratchEventsHistory !== null
      ? userScratchEventsHistory?.list.length > 0
        ? userScratchEventsHistory?.list.map((x) => {
            const obj = {
              "Event Name": x?.eventName || "N/A",
              Customer: x?.phone || "N/A",
              "Activate At": moment(x?.startDate).format(format1).toString() || "N/A",
              "Total Recharge": centToDollar(x?.totalRecharge) || "0",
              [`Day ${scratchEventStaticDays[0].value} (level / required / received)`]: scratched(x?.scratchCards, 0),
              [`Day ${scratchEventStaticDays[1].value} (level / required / received)`]: scratched(x?.scratchCards, 1),
              [`Day ${scratchEventStaticDays[2].value} (level / required / received)`]: scratched(x?.scratchCards, 2),
              "Expire Date": moment(x?.expiryDate).format(format1).toString()
            };
            return obj;
          })
        : []
      : [];
  };

  const SCRATCH_EVENT_ID = searchParams.get("scratchEventId");
  useEffect(() => {
    if (!SCRATCH_EVENT_ID) return;
    const newParams = new URLSearchParams(searchParams);
    setSelectFilter(["Scratch Event"]);
    setPayloadData((prev) => ({ ...prev, scratchEventId: SCRATCH_EVENT_ID }));
    // Only update (and re-fetch) when the id actually differs from what the
    // filter was already seeded with on mount — avoids a second, unfiltered
    // fetch racing the correct one.
    setDataFilter((prev) =>
      prev.scratchEventId === SCRATCH_EVENT_ID ? prev : { ...prev, scratchEventId: SCRATCH_EVENT_ID }
    );

    newParams.delete("scratchEventId");
    setSearchParams(newParams, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SCRATCH_EVENT_ID]);

  useEffect(() => {
    const { activeDateStart, activeDateEnd, expiryDateStart, expiryDateEnd, ...rest } = dataFilter;
    const formdata = new FormData();
    if (activeDateStart && activeDateEnd) {
      formdata.append("activeDateStart", activeDateStart);
      formdata.append("activeDateEnd", activeDateEnd);
    }
    if (expiryDateStart && expiryDateEnd) {
      formdata.append("expiryDateStart", expiryDateStart);
      formdata.append("expiryDateEnd", expiryDateEnd);
    }

    const payload = filterOBJ({
      ...rest,
      activeDateStart: activeDateStart ? toLocalISOString(formdata.get("activeDateStart")) : "",
      activeDateEnd: activeDateEnd ? toLocalISOString(formdata.get("activeDateEnd")) : "",
      expiryDateStart: expiryDateStart ? toLocalISOString(formdata.get("expiryDateStart")) : "",
      expiryDateEnd: expiryDateEnd ? toLocalISOString(formdata.get("expiryDateEnd")) : ""
    });
    dispatch(getScratchEventHistoryList(payload));
  }, [dispatch, dataFilter]);

  return (
    <ScratchEventLayout>
      <Box width="100%" backgroundColor={palette.background.default}>
        <Grid container spacing={gridSpacing}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Box display="flex" alignItems="baseline" gap="8px" mb="4px">
              <Button
                sx={{ p: 0.5 }}
                color="dark"
                variant="link"
                startIcon={<DownloadIcon width="20px" height="20px" color={palette.grey.main} />}
                onClick={() => ExportToCsv(`${name} History.xls`, dataExport())}
              >
                Export
              </Button>
              <ListFilterMain
                setReqData={setDataFilter}
                selectFilter={selectFilter}
                setSelectFilter={setSelectFilter}
                payLoadData={payLoadData}
                setPayloadData={setPayloadData}
              />
            </Box>
          </Grid>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Card sx={{ overflow: "visible" }}>
              <DataTable
                cols={tableConstants({ handleSort })}
                data={
                  userScratchEventsHistory?.list?.length > 0
                    ? userScratchEventsHistory?.list?.map((distributor, i) => ({
                        index: dataFilter.limit * dataFilter.page - dataFilter.limit + (i + 1),
                        ...distributor
                      }))
                    : []
                }
                isStickyHide={true}
                total={userScratchEventsHistory?.totalDocs}
                dataFilter={dataFilter}
                setDataFilter={setDataFilter}
                onBatchChange={onBatchChange}
                isLoading={isLoading}
                tableCall={8}
              />
            </Card>
          </Grid>
        </Grid>
      </Box>
    </ScratchEventLayout>
  );
};

export default ScratchEventHistory;
